import React, { useContext } from 'react'
import { Box, Drawer, styled } from '@mui/material'
import { LayoutContext } from '../layout'
import { AppMenu } from '../router'
import { InternDrawerProps } from './InternDrawer.types'
import TenantSwitch from './TenantSwitch'

const DrawerNav = styled('nav')(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up('md')]: {
        flexShrink: 0,
        display: 'flex',
    },
}))

export function InternDrawer({ tenantId, routes }: InternDrawerProps) {
    const layoutContext = useContext(LayoutContext)

    return (
        <DrawerNav
            sx={{
                '& .MuiDrawer-paper': {
                    width: layoutContext.drawer.width,
                },
            }}
        >
            <Drawer
                id="drawer"
                anchor="left"
                variant={layoutContext.mobile ? 'temporary' : 'persistent'}
                open={!layoutContext.mobile || layoutContext.drawer.open}
                onClose={
                    layoutContext.mobile
                        ? () => layoutContext.openDrawer(false, false)
                        : undefined
                }
            >
                <Box
                    id="drawer-menu"
                    sx={(theme) => {
                        return {
                            visibility: layoutContext.drawer.open
                                ? 'visible'
                                : 'hidden',
                            minWidth: layoutContext.mobile
                                ? layoutContext.drawer.width
                                : 'unset',
                            marginTop: theme.spacing(8),
                        }
                    }}
                >
                    <TenantSwitch />
                    <AppMenu routes={routes} />
                </Box>
            </Drawer>
        </DrawerNav>
    )
}
